<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card card-padding-top">
                <app-empty-content [isVisible]="data.length === 0"
                    title="Nenhum prestador de serviço encontrado"
                    description="Não foi encontrado nenhum prestador de serviço nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <div class="table-scroll-container" *ngIf="data.length > 0">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Nome / Razão Social</th>
                                <th>Papel</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of data">
                                <td>
                                    <div class="dash-card-item p-0"
                                        style="display: flex; align-items: center;">
                                        <div
                                            class="dash-card-item-initials mr-3">
                                            <span>{{ getInitials(item.name)
                                                }}</span>
                                        </div>
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                {{ item.name }}
                                            </div>
                                            <div
                                                class="dash-card-item-content-subtitle">
                                                {{ item.document ?
                                                formatDocument(item.document) :
                                                '-' }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{ item.provider_type }}
                                        </div>
                                        <div
                                            class="dash-card-item-content-subtitle">
                                            {{ item.role }}
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center" *ngIf="canView">
                                    <svg-icon src="assets/images/icon-eye.svg"
                                        style="cursor: pointer;"
                                        (click)="openModalById(item.id)"></svg-icon>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <ng-container
                *ngIf="approvalService.approvalData.mainVersion && approvalService.approvalData.mainRevision">
                <div class="dash-details-card card-padding-top">
                    <app-empty-content [isVisible]="mainData.length === 0"
                        title="Nenhum prestador de serviço encontrado"
                        description="Não foi encontrado nenhum prestador de serviço nesse cadastro"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>

                    <div class="table-scroll-container"
                        *ngIf="mainData.length > 0">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Nome / Razão Social</th>
                                    <th>Papel</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of mainData">
                                    <td>
                                        <div class="dash-card-item p-0"
                                            style="display: flex; align-items: center;">
                                            <div
                                                class="dash-card-item-initials mr-3">
                                                <span>{{ getInitials(item.name)
                                                    }}</span>
                                            </div>
                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    {{ item.name }}
                                                </div>
                                                <div
                                                    class="dash-card-item-content-subtitle">
                                                    {{ item.document ?
                                                    formatDocument(item.document)
                                                    : '-' }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                {{ item.provider_type }}
                                            </div>
                                            <div
                                                class="dash-card-item-content-subtitle">
                                                {{ item.role }}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center" *ngIf="canView">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"
                                            style="cursor: pointer;"
                                            (click)="openModalById(item.id)"></svg-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.mainVersion || !approvalService.approvalData.mainRevision">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container
                *ngIf="approvalService.approvalData.comparingVersion && approvalService.approvalData.comparingRevision">
                <!-- Skeleton para tabela -->
                <div class="dash-details-card card-padding-top"
                    *ngIf="comparingDataLoading">
                    <div class="table-scroll-container">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Nome / Razão Social</th>
                                    <th>Papel</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let i of [1, 2]">
                                    <td>
                                        <div
                                            style="display: flex; align-items: center; gap: 12px;">
                                            <ngx-skeleton-loader [theme]="{
                                                height: '40px',
                                                width: '40px',
                                                borderRadius: '50%'
                                            }"></ngx-skeleton-loader>
                                            <div>
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '16px',
                                                    width: '150px',
                                                    marginBottom: '8px'
                                                }"></ngx-skeleton-loader>
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '14px',
                                                    width: '120px'
                                                }"></ngx-skeleton-loader>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <ngx-skeleton-loader [theme]="{
                                                height: '16px',
                                                width: '100px',
                                                marginBottom: '8px'
                                            }"></ngx-skeleton-loader>
                                            <ngx-skeleton-loader [theme]="{
                                                height: '14px',
                                                width: '80px'
                                            }"></ngx-skeleton-loader>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '20px',
                                            width: '20px',
                                            borderRadius: '50%'
                                        }"></ngx-skeleton-loader>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="row" *ngIf="!comparingDataLoading">
                    <div class="col-12">
                        <div class="dash-details-card card-padding-top">
                            <app-empty-content
                                [isVisible]="comparingData.length === 0"
                                title="Nenhum prestador de serviço encontrado"
                                description="Não foi encontrado nenhum prestador de serviço nesse cadastro"
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>

                            <div class="table-scroll-container"
                                *ngIf="comparingData.length > 0">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Nome / Razão Social</th>
                                            <th>Papel</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of comparingData"
                                            [class]="item.compareClass">
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-check-filled.svg"
                                                        *ngIf="item.compareClass === 'row-compare-added'"
                                                        class="text-success"></svg-icon>
                                                    <svg-icon
                                                        src="assets/images/icon-times-circle.svg"
                                                        *ngIf="item.compareClass === 'row-compare-removed'"
                                                        class="text-danger"></svg-icon>
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="item.compareClass === 'row-compare-modified' && item.changedFields?.name"
                                                        class="text-warning"></svg-icon>
                                                    <div class="dash-card-item p-0"
                                                        style="display: flex; align-items: center;">
                                                        <div
                                                            class="dash-card-item-initials mr-3">
                                                            <span>{{
                                                                getInitials(item.name)
                                                                }}</span>
                                                        </div>
                                                        <div
                                                            class="dash-card-item-content">
                                                            <div class="dash-card-item-content-title"
                                                                [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                                {{ item.name }}
                                                            </div>
                                                            <div class="dash-card-item-content-subtitle"
                                                                [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                                {{ item.document
                                                                ?
                                                                formatDocument(item.document)
                                                                : '-' }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="item.changedFields?.provider_type"
                                                        class="text-warning"></svg-icon>
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="item.changedFields?.role"
                                                        class="text-warning"></svg-icon>
                                                    <div
                                                        class="dash-card-item-content">
                                                        <div class="dash-card-item-content-title"
                                                            [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                            {{
                                                            item.provider_type
                                                            }}
                                                        </div>
                                                        <div class="dash-card-item-content-subtitle"
                                                            [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                            {{ item.role }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-center"
                                                *ngIf="canView">
                                                <svg-icon
                                                    src="assets/images/icon-eye.svg"
                                                    style="cursor: pointer;"
                                                    (click)="openModalById(item.id)"></svg-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.comparingVersion || !approvalService.approvalData.comparingRevision">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>
    </div>
</ng-container>